<template>
    <div class="video lms-center" id="videoBox" @mouseover="onMouseOver" @mouseleave="onMouseleave" ref="videoBox" @webkitfullscreenchange="fullscreenchange">
        <div class="video-err" v-if="videoFail && !loading">
            {{videoErrorMe}}<a class="video-reload" @click="videoReload" v-show="reloadState" href="javascript:;">重新加载!</a>
        </div>
        <div class="video-loading" v-loading="loading"></div>
        <div class="circle-loading"  v-if="bufferedLoading">
            <circle-loading :styles="{width:'40px',height:'40px'}"/>
        </div>
        <video
            ref="video"
            currentTime="0"
            controlslist="nodownload nofullscreen noremoteplayback noremote footbar"
            preload
            :class="['outline','p-pointer',{'p-nothave':cursorState}]"
            :src="videoApi && videoApi"
            :disablePictureInPicture="true"
            x5-video-player-type="h5"
            v-show="!videoFail"
            v-if="!videoFail && videoApi"
            @click.stop="playClick"
            @ended="onPlayerEnded($event)"
            @timeupdate="onTimeupdate($event)"
            @loadedmetadata="onloadedmetadata($event)"
            @contextmenu="oncontextmenu($event)"
            @mousemove="setElControlsHide"
            @mouseover="setElControlsHide"
            @error="onError"
            @stalled="onstalled"
            @suspend="onsuspend"
            @waiting="onwaiting"
            @canplay="oncanplay"
            @abort="onabort"
            @progress="onprogress"
            @ratechange="onratechange"
            @seeking="onseeking"
        >
        您的浏览器不支持 video 播放。
        </video>
        <div class="video-play p-pointer el-icon-video-play" v-show="!play && !!videoApi && !loading" @click.stop="playClick"></div>
        <div class="video-history" v-show="!!playTime && videoApi && playTimeState && !loading">上次觀看到:{{serVideoTime(playTime)}} <span class="p-pointer" @click="playTimeData">跳轉</span></div>
        <div class="video-controls" v-show="(controls || !play) && !!videoApi && !loading">
            <div class="video-controls-currentTime">{{currentTime}}/{{duration}}</div>
            <video-progress 
                :playingStatus="playingStatus"
                :progress="progress"
                :buffered="buffered"
                @setControlsProgress="setControlsProgress"
                @currentTimeChang="currentTimeChang"
             />
            <div class="video-controls-screen p-pointer" @click="screenClick">
                <svg v-if="!fullscreen" class="icon" aria-hidden="true">
                    <use xlink:href="#iconquanpingbofang"></use>
                </svg>
                <img v-else :src="require('@p/assets/images/icon/suofang.png')">
            </div>
        </div>
    </div>
</template>

<script>
import {runPrefixMethod} from '@p/utils/method'
import { setMinuteSecond } from '@/utils'
import circleLoading from '@p/components/circleLoading'
import videoProgress from './progress.vue'
export default {
    components: {
        circleLoading,
        videoProgress
    },
    data(){
        return {
            controls:false,             //控件
            play:false,                 //播放
            progress:'',                //进度
            currentTime:'00:00',        //时间
            duration:'00:00',           //时长
            fullscreen:false,           //全屏
            playTimeState:true,         //历史记录显示状态
            time:'',
            cursorState:false,          //指针状态
            videoFail: false,
            videoErrorMe: '',
            loading: true,
            bufferedLoading: false,      // 缓存loading
            buffered:'',                // 缓存进度
            mouseState: true,           // 鼠标移入video状态
            reloadState: false,         // 重新加载
        }
    },
    props:{
        videoApi:{
            type:[String,Boolean],
        },
        playTime:{
            type:[String,Number],
        },
        playingStatus:{
            type:[Boolean,String],
        },
        resourceError:{
            type:[String,Boolean],
        }
    },
    computed: {
    },
    watch:{
        videoApi:function(v){       //播放地址改变重置进度
            this.progress={width:"0px"};
            this.play=false;
            this.playTimeState=true;
            this.loading = true
            this.videoFail = false
            this.reloadState = false
            this.resourceStatus()
        },
    },
    mounted () {
        this.resourceStatus()
    },
    methods:{
        resourceStatus () {
            if (this.resourceError) {
                this.loading = false
                this.videoFail = true
                this.videoErrorMe = '此課堂在外部網絡下無法學習，請連接內部網絡。'
            } else {
                this.videoErrorMe = ''
            }
        },
        //全屏状态下不操作隐藏控件
        setElControlsHide(){
            if(this.fullscreen && this.play){
                this.controls=true;
                this.cursorState=false;
                clearInterval(this.time);
                this.time=setInterval(()=>{ //隐藏控件
                    this.controls=false;
                    this.cursorState=true; //隐藏指针
                },5000)
            }
        },
        fullscreenchange(){
            this.fullscreen=!this.fullscreen;
            if(!this.fullscreen){
                clearInterval(this.time);
                this.cursorState=false;
            }
        },
        //播放
        playClick(){
            if (this.$refs.video.readyState !== 0 && !this.loading) {
                this.play=!this.play;
                if(this.play){
                    this.$refs.video.play();
                }else{
                    this.$refs.video.pause();
                }
                this.$emit('videoStateChang', this.play)
                this.playTimeState=false;
                this.bufferedLoading = false
            }
        },
        // 播放到指定位置
        playCurrentTime () {
            if (this.playingStatus === false && this.$refs.video.currentTime === 0) {
                this.$refs.video.currentTime = this.playTime;
                this.$emit('resetAccessTime', !!this.playTime ? -1 : 0)
            }
        },
        //播放结束
        onPlayerEnded(e){
            this.$emit('playerEnded')
            this.play=!this.play;
        },
        // 播放进度
        onTimeupdate(e){
            let timeCurrentTime = Math.floor(e.target.currentTime);
            let timeduration = Math.floor(e.target.duration);
            this.currentTime=this.serVideoTime(e.target.currentTime);
            this.progress={
                width: (timeCurrentTime / timeduration) * 100 + '%',
            }
            this.$emit('playChang',e.target.currentTime);
        },
        //视频已加载
        onloadedmetadata(e){
            this.bufferedLoading = false
            this.videoFail = false
            this.videoErrorMe = ''
            this.duration=this.serVideoTime(e.target.duration)
            if (this.playingStatus) {
                this.loading = false
            }
            // if (this.playTime >= parseInt(e.target.duration)) {
            //     this.playTimeState = false
            // }
            setTimeout(()=>{
                this.loading = false
                this.playCurrentTime()
            }, 2000)
            console.log('视频已加载')
        },
        //设置播放时间
        serVideoTime(v){
            let hour = Math.floor (v / 3600);
            let other = v % 3600;
            let minute = Math.floor (other / 60);
            let second = Math.floor(other % 60);
                minute=minute<10 ? '0'+minute : minute;
                second=second<10 ? '0'+second : second;
            if(hour>0){
                hour=hour<10 ? '0'+hour+':' : hour+':';
            }else{
                hour='';
            }
            return hour + minute + ':' + second;
        },
        //播放历史记录
        playTimeData(){
            this.playClick();
            this.$refs.video.currentTime=this.playTime;
            if (this.playingStatus) {
              this.$emit('resetAccessTime', -1)
            }
        },
        // 全屏，退出全屏
        screenClick(){
            if(!this.fullscreen){
                runPrefixMethod(this.$refs.videoBox,'RequestFullScreen');
            }else{
                runPrefixMethod(document,'CancelFullScreen');
            }
        },
        // 控制进度条
        setControlsProgress (value) {
            this.progress = {
                width: `${value}%`
            }
        },
        // 控制进度条播放
        currentTimeChang (value) {
            this.play = true
            this.playTimeState = false;
            this.bufferedLoading = false
            this.$refs.video.currentTime = value;
        },
        //阻止右键
        oncontextmenu(e){
            e.preventDefault();
            return false;
        },
        // 视频重新加载
        videoReload () {
            this.$emit('videoReload')
        },
        // 监听视频加载失败
        onError(e){
            this.videoFail = true;
            this.controls = false;
            this.play = true;
            this.playTimeState = false
            this.bufferedLoading = false
            this.reloadState = false
            this.$http.course.getLmsOSS(this.videoApi).then(res => {
                this.loading = false
                this.videoErrorMe = '視頻資源獲取失敗，請稍後再試！'
            }).catch( err => {
                this.loading = false
                try {
                    if (err.response.status === 403) {
                        this.reloadState  = true
                        this.videoErrorMe = '視頻鏈接已失效，請'
                    } else if (!this.resourceError) {
                        this.videoErrorMe = '視頻資源獲取失敗，請稍後再試！'
                    }
                } catch {
                    this.videoErrorMe = '視頻資源獲取失敗，請稍後再試！'
                }
            });
        },
         // 鼠标移入
        onMouseOver(){
            if (this.videoFail) {
                return;
            }
            this.controls = true;
        },
        // 鼠标移出
        onMouseleave(){
            this.controls = false
        },
        //等待数据，并非错误
        onwaiting(){
            this.bufferedLoading = true
            console.log('等待数据，并非错误')
        },
        //可以播放，但中途可能因为加载而暂停
        oncanplay(){
            this.bufferedLoading = false
            console.log('可以播放，但中途可能因为加载而暂停')
        },
        //正在请求数据
        onprogress(e){
            const duration = Math.floor(e.target.duration);
            if (e.target.buffered.length != 0) {
                const buffered = Math.floor(e.target.buffered.end(0));
                this.buffered = {
                    width: `${(buffered / duration) * 100}%`
                }
            }
            console.log('onprogress:正在请求数据')
        },
        //网速失速
        onstalled(){
            console.log('onstalled:网速失速')
        },
        //延迟下载
        onsuspend(){
            console.log('onsuspend:延迟下载')
        },
        //客户端主动终止下载
        onabort(){
            console.log('onabort:客户端主动终止下载')
        },
        //播放速率改变
        onratechange(){
            console.log('onratechange:播放速率改变')
        },
        //寻找中
        onseeking(){
            console.log('onseeking:寻找中')
        },
    },
    beforeDestroy(){
        clearInterval(this.time);
    },
}
</script>

<style lang="less">
    .video-loading{
        position: absolute;
        left: 50%;
        margin-left: -20px;
        .el-loading-mask{
            background-color: rgb(0, 0, 0);
            z-index: 1000;
        }
    }
    .circle-loading{
        position: absolute;
        left: 50%;
        .circle span{
            width: 6px;
            height: 6px;
        }
    }
</style>

<style lang="less" scoped>
.video{
    width: 100%;
    background: none;
    height: 100%;
    background: #000000;
    position: relative;
    overflow: hidden;
    .video-reload{
        color: rgb(77, 142, 246);
    }
    .video-err{
        color: #d0bd2d;
    }
    video{
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    &-play{
        position: absolute;
        font-size: 96px;
        color:rgba(77,142,246,1);
    }
    &-history{
        position: absolute;
        left: 0;
        bottom: 60px;
        padding: 5px;
        background: rgba(0, 0, 0, 0.5);
        color: #ffff;
        >span{
            color: #f7c981;
        }
    }
    &-controls{
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 48px;
        padding: 0 14px 0 30px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color:rgba(234,234,243,1);
        background: rgba(0, 0, 0, .5);
        &-currentTime{
            flex: 0 0 100px;
            margin-bottom: 2px;
        }
        &-screen{
            svg{
                font-size: 18px;
            }
        }
    }
}
</style>
